const React = require('react');

exports.Faq = class Faq extends React.Component{
   constructor(props) {
      super(props);
   }

   render() {

      return (
         <div className='container-fluid faq-container'>
            <h1>Polypedia</h1>
            <h3>General</h3>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">1. Polyplexus</h5>
                  </div>
                  <p>
                     Polyplexus, an R&D propulsion lab, is a global platform designed to accelerate access to scientific evidence,
                     hypothesis development, research proposal generation and sponsor engagement. Developed for scientific researchers and research sponsors,
                     the platform creates a database of easily accessible cited evidence and disrupts the current research process to facilitate faster idea generation and cross-disciplinary
                     collaboration.
                  </p>
                  <p>
                     Polyplexus core functions include:  the ability to add Evidence; the ability to link two pieces of Evidence with a Conjecture;
                     the ability to collect Evidence and Conjectures in a private Portfolio; the ability to share Portfolios and create proposal outlines; the ability to connect with a research sponsor
                     in an Incubator and compete for award funding.
                  </p>
                  <p>
                     For more information on Polyplexus, view the following video:
                  </p>
                  <iframe width="560" height="315" src="https://www.youtube.com/embed/zSiPanzZ25Y" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                  <br></br>
                  The complete Polyplexus instructions manual can be found at this <a href={window.globals.STATIC_ASSETS_BASE_URL+'/unversioned/documents/Instructions_Manual.docx'}>link</a>.
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">2. Our Purpose</h5>
                  </div>
                  <p className="mb-1">
                     Polyplexus aims to help researchers and those interested in groundbreaking ideas by
                  </p>
                  <ul>
                     <li>Leveraging global digital platform technologies and network opportunities</li>
                     <li>Amassing an easily accessible public database of cited evidence</li>
                     <li>Accelerating rigorous hypothesis and research proposal development</li>
                     <li>Facilitating efficient access to a greater pool of research funding opportunities</li>
                     <li>Creating easy cross-disciplinary opportunities for collaboration</li>
                  </ul>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">3. Our Benefits</h5>
                  </div>
                  <p className="mb-1">
                     As the platform evolves, participation affords Plexors an increasing number of benefits, including:
                  </p>
                  <ul>
                     <li>Accelerated R&D process</li>
                     <li>Instant connection to a global, cross-disciplinary expert network of science and technology professionals </li>
                     <li>Access to a public knowledge base</li>
                     <li>Public and private collaborative work spaces</li>
                     <li>Focused proposal building</li>
                     <li>Direct connections with research sponsors through public and private (invitation-only) Incubators</li>
                  </ul>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">4. Polyplexus and Research Funding</h5>
                  </div>
                  <p>
                     The research funding process arising from an Incubator discussion is determined by the research sponsor hosting the Incubator.
                     Availability of research funding and the funding process will be noted in each individual Incubator description.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">5. Who We Are</h5>
                  </div>
                  <p>
                     Polyplexus is being developed by <a href="https://www.aixxia.com/">Aixxia</a>, a not-for-profit consortium of cross-disciplinary experts,
                     dedicated to exploring different means of amplifying the power of science through invention and innovation. The development of the Polyplexus platform was funded by a DARPA grant.
                  </p>
                  <p>
                     For more information on the Polyplexus team, view the following video:
                  </p>
                  <iframe width="560" height="315" src="https://www.youtube.com/embed/D4inZw7y3a8" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">6. DARPA and Polyplexus</h5>
                  </div>
                  <p className="mb-1">
                     DARPA believes it is critical to foster scientific collaboration and imagination to compete in today’s highly connected marketplace.
                     Research and development is a global and intensely competitive enterprise, impacted by digital and network disruptors that increase the speed and dissolve the borders of idea exchange.
                     Organizations focused on shaping the future need to leverage every possible advantage to succeed in this environment.
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">7. Participation </h5>
                  </div>
                  <p className="mb-1">
                     Polyplexus is an open, public platform. To create an account, visit <a href="https://polyplexus.com/register">this page</a>.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">8. Access to Content</h5>
                  </div>
                  <p className="mb-1">
                     Once they have created an account, Plexors can view and create Evidence and Conjecture Micropublications,
                     develop Portfolios for abstract and proposal development, engage in private group discussion,
                     team for proposal development and participate in public and private (invitation-only) research sponsor-led Incubators.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">9. Content Ownership</h5>
                  </div>
                  <p>
                     The platform’s basic building blocks of Evidence Micropublications (or µPubs) and Conjectures are public and the username is traceable to the contributor.
                  </p>
                  <p>
                     If the contributor uses their real name a Creative Commons license with attribution is attached to the contribution.
                     If the contributor uses a screen name, the Creative Commons license without attribution applies. A final research proposal,
                     built upon Evidence µPubs and Conjecture µPubs, belongs to an  individual or team of contributors and is not public unless the contributors wish to publish it.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">10. Platform Moderator</h5>
                  </div>
                  <p className="mb-1">
                     There is a moderator, per the user agreement.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">11. Community Manager</h5>
                  </div>
                  <p className="mb-1">
                     The community manager can be reached at monica@polyplexus.com
                  </p>
               </div>
               <h3>
                  Using Polyplexus: Terminology and Key Activities
               </h3>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Polyplexus Propulsion Loop</h5>
                  </div>
                  <p className="mb-1">
                     Representation of the key activities, functionalities, and opportunities within Polyplexus, viewable on the home page.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Plexor</h5>
                  </div>
                  <p className="mb-1">
                     A participant on Polyplexus.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Plexing</h5>
                  </div>
                  <p className="mb-1">
                     A way of referring to Plexor activity on Polyplexus.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Profile</h5>
                  </div>
                  <p className="mb-1">
                     Polyplexus provides Plexors with the option to customize their profile with their picture, expertise, and interests so fellow Plexors can learn more about them.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Founding Member</h5>
                  </div>
                  <p className="mb-1">
                     Forty Plexors achieved Founding Member status on the platform. They were involved in the pre-alpha phase of Polyplexus and have been instrumental in testing and building key aspects of
                     the platform, including the initial library of Evidence and Conjecture µPubs. Plexors with Founding Member status were able to compete for six 2018 DARPA grants.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Evidence Micropublication</h5>
                  </div>
                  <p className="mb-1">
                     An Evidence Micropublication, or µPub, refers to an individual, sourced, and rigorous piece of evidence.
                     It is a one-sentence statement that summarizes evidence so that it is quickly and publicly searchable by other Plexors.
                  </p>
                  <p>
                     For more information on creating an Evidence µPub, view the video tutorial here:
                  </p>
                  <iframe width="560" height="315" src="https://www.youtube.com/embed/IBGBn-meW5k" frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen> </iframe>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Appropriate Sources for Evidence Micropublications</h5>
                  </div>
                  <p className="mb-1">
                     Appropriate sources of evidence include primary papers, patents and review articles from peer-reviewed technical publications --
                     published journal articles or articles on pre-print servers. Secondary reporting from digests and newspapers is not appropriate.
                  </p>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Peer Review of Evidence Micropublications</h5>
                  </div>
                  <p className="mb-1">
                     Evidence µPubs are subject to a peer review process before they are published. Every Plexor who is reviewing an Evidence µPub is asked to select one review comment for the µPub:
                  </p>
                  <ul>
                     <li>The Evidence µPub meets the criteria for acceptance</li>
                     <li>The Evidence µPub appears to be cut-off or incomplete</li>
                     <li>The citation is incomplete</li>
                     <li>The citation is not from a peer reviewed source</li>
                     <li>The Evidence µPub should be reworded for clarity</li>
                     <li>The Evidence µPub is actually a Conjecture </li>
                     <li>The Evidence µPub is not supported by the reference</li>
                     <li>The Evidence µPub is outside my domain and I don't feel comfortable reviewing it</li>
                  </ul>
               </div>
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Evidence Micropublication Changes</h5>
                  </div>
                  <p className="mb-1">
                     Once it is published, the author of an Evidence µPub can no longer change it. As long as an Evidence µPub is in the peer review process, the author can delete it and resubmit a better version.
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Evidence Micropublication List View</h5>
                  </div>
                  <p className="mb-1">
                     Evidence µPubs that have been reviewed and accepted are published in the center panel’s list view. Filters can be applied to the list view to sort it by any topic, keyword, or combination.
                     The most recently published Evidence µPubs appear at the top of the list.
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Conjecture Micropublication</h5>
                  </div>
                  <p className="mb-1">
                     A Conjecture µPub is a preliminary and public hypothesis which links two pieces of Evidence with a question.  A Conjecture µPub is easy to create and takes four simple steps:
                  </p>
                  <ul>
                     <li>
                        favorite Evidence µPubs from the list
                     </li>
                     <li>
                        select two Evidence µPubs
                     </li>
                     <li>
                        bond the two Evidence µPubs with a question
                     </li>
                     <li>
                        hit submit
                     </li>
                  </ul>
                  <p>
                     Your Conjecture µPub then goes into review by the Plexor community.
                     Note, a Conjecture µPub must always be formulated as a question.
                  </p>
                  <p>
                     For more information on creating a Conjecture µPub, view the video tutorial here:
                  </p>
                  <iframe width="560" height="315" src="https://www.youtube.com/embed/wih4NmcAf3k" frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen> </iframe>
               </div>
               <div className="list-group">
                  <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                     <div className="d-flex w-100 justify-content-between">
                        <h5 className="mb-1">Peer Review of Conjecture Micropublications</h5>
                     </div>
                     <p>
                        Conjecture µPubs are subject to a peer review process before they are published. Plexors who are reviewing a Conjecture µPub may approve or reject
                        the Conjecture µPub based on the following statement:
                     </p>
                     <p>
                        "Conjecture should not contain objectionable, unprofessional, rude, or other similar content."
                     </p>
                     <p>
                        Each Plexor can give a maximum of 1 approve or reject vote to 1 Conjecture µPub. Each Conjecture µPub must receive at least 3 approve votes,
                        out of 5 reviews, before it is published for use by the community.
                     </p>
                  </div>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Conjecture µPub Changes</h5>
                  </div>
                  <p className="mb-1">
                     Once a Conjecture µPub has been published it cannot be changed. While it is still in review the author can delete it.
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Conjecture µPub List View</h5>
                  </div>
                  <p className="mb-1">
                     Selecting “View & Create µPubs” in the menu brings up an area on the left for creating µPubs and a list of all published µPubs on the right.
                     Within that list, the Conjecture µPubs are shaded purple (Evidence µPubs are shaded blue).
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Portfolio</h5>
                  </div>
                  <p>
                     This functionality allows Plexors to organize collected Evidence and Conjecture µPubs into a flow, add their thoughts and notes, and invite other Plexors to
                     collaborate with them as they flesh out their research ideas. Portfolios are private work spaces. Only those invited in by a Plexor can view the contents of any given Portfolio.
                  </p>
                  <p>
                     Note, Polyplexus recommends Plexors come to a mutual agreement before sharing a Portfolio with others.
                     It is up to the individual owner of a Portfolio to address IP and other questions that will govern the collaboration.
                  </p>
                  <p>
                     For more information on creating a Portfolio, view the video tutorial here:
                  </p>
                  <iframe width="560" height="315" src="https://www.youtube.com/embed/QQY44Z4HuyA" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Portfolio Creation</h5>
                  </div>
                  <p className="mb-1">
                     Creating a Portfolio takes four easy steps:
                  </p>
                  <ol>
                     <li>Create: Gather all the Evidence and Conjecture µPubs in one place to support a research idea</li>
                     <li>Organize: Order the Evidence and Conjecture µPubs in the Portfolio to match the flow of the research argument</li>
                     <li>Add: Create text blocks to capture personal notes</li>
                     <li>Collaborate: Invite other Plexors to work on a research idea</li>
                  </ol>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Incubator</h5>
                  </div>
                  <p className="mb-1">
                     An Incubator is a sponsor-led portfolio with solicitation and award attached. It may be public or private (invite-only).
                  </p>
                  <p>
                     An Incubator includes three main areas:
                  </p>
                  <ol>
                     <li>Overview: introduction to the area of inquiry by the Sponsor</li>
                     <li>Q&A: ability for Plexors to ask questions of the Sponsor</li>
                     <li>µPubs: area where Plexors can add their Evidence and Conjecture µPubs or that of others</li>
                  </ol>
                  <p>
                     An Incubator will provide up to eight dates to guide Plexors, though not all dates necessarily apply:
                  </p>
                  <p>
                     Incubator Launch Announcement <br />
                     When will the Plexor community hear about the Incubator?
                  </p>
                  <p>
                     Incubator Display Date <br />
                     When will the Incubator be posted, so Plexors can begin to contribute?
                  </p>
                  <p>
                     End of Suggestion Period <br />
                     When will the Incubator close to Plexor contributions?
                  </p>
                  <p>
                     Description Finalized <br />
                     When will the Incubator post the final research description for abstract solicitation?
                  </p>
                  <p>
                     Abstracts Due Date <br />
                     What is the Incubator’s deadline for submitting abstracts?
                  </p>
                  <p>
                     Extended Abstracts Due Date <br />
                     What is the Incubator’s deadline for submitting extended abstracts? (if required)
                  </p>
                  <p>
                     Proposal Due Date <br />
                     What is the Incubator’s deadline for proposal submission?
                  </p>
                  <p>
                     Projected Award Date <br />
                     When will the winning proposal(s) be awarded and announced?
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Public vs. Private (Invite-only) Incubator</h5>
                  </div>
                  <p className="mb-1">
                     There are two types of Incubators. <br />
                     Public ones, where the entire Plexor community is invited to contribute; and private ones, where the Sponsor will issue invites to participate.
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Research Sponsor</h5>
                  </div>
                  <p className="mb-1">
                     Institution that hosts an Incubator to address a specific research question.
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Solicitation</h5>
                  </div>
                  <p className="mb-1">
                     Formal Incubator request for proposal.
                  </p>
               </div>
            </div>

            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Proposal</h5>
                  </div>
                  <p className="mb-1">
                     Final submission to an Incubator.
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Award</h5>
                  </div>
                  <p className="mb-1">
                     Plexor funding tied to a winning proposal submitted to an Incubator.
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Winner Circle</h5>
                  </div>
                  <p className="mb-1">
                     Plexors whose proposal receives funding from an Incubator automatically become a member of the Winner Circle.
                     Currently, six Plexors are members of the Winner Circle. Each of them won a 2018 DARPA grant.
                  </p>
               </div>
            </div>
            <div className="list-group">
               <div className='list-group-item list-group-item-action flex-column align-items-start"'>
                  <div className="d-flex w-100 justify-content-between">
                     <h5 className="mb-1">Polyplexus Updates</h5>
                  </div>
                  <p className="mb-1">
                     Open to the public since February 2019, the Polyplexus team  will continue to evolve the platform experience.
                  </p>
               </div>
            </div>
            <h5>
               Plexor suggestions are welcome and appreciated. Reach out to Monica, the community manager with ideas and questions.
               DM her on Polyplexus at ‘Monica Meyers’ or send her an email at monica@polyplexus.com.
            </h5>
            <br />
            <h5>Anything we didn’t cover? Please contact us directly at info@polyplexus.com or DM us on <a href="https://twitter.com/polyplexors">Twitter</a>
               &nbsp;or <a href="https://instagram.com/polyplexors/">Instagram</a> @polyplexors.
            </h5>
            <h5>
               <a href="https://s3-us-west-2.amazonaws.com/plexus-static/PolyplexusUserAgreement.pdf">
                  Terms of Service and Privacy Policy
               </a>
            </h5>
         </div>
      );
   }
};
